import React, { useState, useEffect } from "react";
import axios from "axios";

const UpcomingPayments = () => {
  const [upcoming, setUpcoming] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterRoom, setFilterRoom] = useState("");

  const getUpcomingPayments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-upcoming-payments`,
        {
          params: { searchName: filterName, searchRoom: filterRoom },
          withCredentials: true,
        }
      );
      setUpcoming(res.data.upcoming || []);
    } catch (err) {
      console.error("Error fetching upcoming payments:", err);
    }
  };

  useEffect(() => {
    getUpcomingPayments();
  }, [filterName, filterRoom]);

  return (
    <div>
      {/* 🔹 Filters */}
      <div className="d-flex gap-2 mb-2">
        <input
          type="text"
          placeholder="Filter by name"
          className="form-control"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Filter by room"
          className="form-control"
          value={filterRoom}
          onChange={(e) => setFilterRoom(e.target.value)}
        />
      </div>

      {/* 🔹 Table */}
      <table className="table table-bordered table-hover">
        <thead className="table-success">
          <tr>
            <th>Guest</th>
            <th>Due On</th>
            <th>Due Amount</th>
            <th>Status</th>
            <th>Room</th>
            <th>Subscription ID</th>
          </tr>
        </thead>
        <tbody>
          {upcoming.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">
                No records found
              </td>
            </tr>
          ) : (
            upcoming.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.next_due_date}</td>
                <td>
                  { `$${Number(item.total_monthly_rent).toFixed(2)}`}
                </td>
                <td>
                  <span
                    className={`badge ${
                      item.status === "completed"
                        ? "bg-success"
                        : "bg-warning text-dark"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td>
                  {item.bedtypename} {item.room_no} {item.property_name}
                </td>
                <td>{item.stripe_subscription_id}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UpcomingPayments;
